import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "boxall",
    style: { "height": "3.5rem" }
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "alltitle" }, "个人借阅排行", -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", {
    class: "allnav",
    id: "echart5"
}, null, -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { class: "boxfoot" }, null, -1);
const _hoisted_5 = [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
];
import windowResize from "@/utils/resize";
import { onMounted, onUnmounted, ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ScreenRightBottom',
    setup(__props) {
        const { screenRef, calcRate, windowDraw, unWindowDraw } = windowResize();
        const loading = ref(true);
        onMounted(() => {
            // 监听浏览器窗口尺寸变化
            windowDraw();
            calcRate();
            setTimeout(() => {
                loading.value = false;
            }, 2000);
        });
        onUnmounted(() => {
            unWindowDraw();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5));
        };
    }
});
